import { differenceInDays } from 'date-fns';

import { VISITOR_LIMIT_COOLDOWN_DAYS } from 'constants/limits';
import { VISITOR_LIMIT_EXCEEDED_DISMISSED_KEY } from 'constants/notification-bar';
import { getItem, saveItem, type LocalStorageItem } from 'services/local-storage';

interface VisitorLimitDismissedData {
  count: number;
  dismissedAt: number;
}

export function shouldShowVisitorLimitNotification(currentCount: number): boolean {
  const dismissedData = getItem<VisitorLimitDismissedData>(VISITOR_LIMIT_EXCEEDED_DISMISSED_KEY);

  if (!dismissedData) {
    return true;
  }

  const daysSinceDismissal = differenceInDays(new Date(), new Date(dismissedData.dismissedAt));

  if (daysSinceDismissal < 0) {
    return true;
  }

  if (daysSinceDismissal >= VISITOR_LIMIT_COOLDOWN_DAYS) {
    return true;
  }

  if (currentCount > dismissedData.count) {
    return true;
  }

  return false;
}

export function markVisitorLimitDismissed(count: number): void {
  const dismissedData: VisitorLimitDismissedData = {
    count,
    dismissedAt: Date.now(),
  };
  saveItem(VISITOR_LIMIT_EXCEEDED_DISMISSED_KEY, dismissedData as unknown as LocalStorageItem);
}
